export default __webpack_public_path__ + "static/Flip Cards-7102527559078b4d15008d4776183cf2.jpg";